import { createAction, props } from '@ngrx/store';
import { createBaseResourceActions } from '../create-base-resource-actions';
import { ScheduledMeetingResourceTypeMappings } from '@aa/nest/resource';

const domainSlug = '[SCHEDULED MEETING]';
export const scheduledMeetingActions = {
  approve: createAction(
    `${domainSlug} Approve`,
    props<{
      id: number;
    }>(),
  ),
  reject: createAction(
    `${domainSlug} Reject`,
    props<{
      id: number;
    }>(),
  ),
  cancel: createAction(
    `${domainSlug} Cancel`,
    props<{
      id: number;
    }>(),
  ),
  ...createBaseResourceActions<ScheduledMeetingResourceTypeMappings>(
    domainSlug,
  ),
};
